import { Environment } from './environment.interface';

const HTTP_URL: RegExp = /^https?:\/\//;

export function toSameOriginUrl(url: string | null, origin: string): string | null {
  if (!url || !HTTP_URL.test(url)) {
    return url;
  }
  const parsed: URL = new URL(url);
  if (parsed.origin === origin) {
    return url;
  }
  return `${origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
}

export function toSameOriginApiUrls(environment: Environment, origin: string): Environment {
  const api: Environment['api'] = Object.fromEntries(
    Object.entries(environment.api).map(([name, url]: [string, string | null]) => [name, toSameOriginUrl(url, origin)]),
  ) as Environment['api'];
  return { ...environment, api };
}
